import { render } from "./LectureTypeLayout.vue?vue&type=template&id=349dba49"
import script from "./LectureTypeLayout.vue?vue&type=script&lang=js"
export * from "./LectureTypeLayout.vue?vue&type=script&lang=js"

import exportComponent from "/opt/goodtoknow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__